<script>
  import { filteredResidents } from '../store.js';
  import { AppController } from '../AppController';
  import { showLoading } from './Overlay.svelte';
  import { toast } from './Toast.svelte';
  import DeleteResidentModal from './DeleteResidentModal.svelte';
  import Pagination from './Pagination.svelte';
  
  let residentToDelete;

  let displayResidents = [];

  const showDeleteModal = (resident) => {
    residentToDelete = resident;
    AppController.displayDeleteResidentModal(true);
  }
  
  const deleteResident = async (resident) => {
    try {
      showLoading(true);
      await AppController.deleteResident(resident);
      toast('success', 3000, 'Deleted', 'Resident was successfully deleted');
    } catch (err) {
      stickyToast('danger', 'Error', 'An error occured while deleting resident.');
    } finally {
      showLoading(false);
    }
  }

  const paginate = (event) => {
    displayResidents = event.detail.items;
  }
</script>
<div class="row">
  <div class="col-md-12 stretch-card">
    <div class="card">
      <div class="card-body">
        <p class="card-title">Residents</p> 
        <div class="table-responsive">
          <table id="residents" class="table table-bordered table-sm">
            <thead>
              <tr>
                <th>Account</th>
                <th>Name</th>
                <th>Address</th>
                <th>City</th>
                <th>Property Type</th>
                <th class='text-center'>Actions</th>
              </tr>
            </thead>
            <tbody>
              {#if displayResidents.length}
                {#each displayResidents as resident}
                  <tr>
                    <td>{resident.ubmax_acc}</td>
                    <td>{resident.first_name} {resident.last_name}</td>
                    <td>{resident.house_number} {resident.street}</td>
                    <td>{resident.city}</td>
                    <td>{resident.property_type}</td>
                    <td class='text-center'>
                      <a href='#/app/resident/{resident.resident_id}'>
                        <i class="mdi mdi-account-edit icon-md mr-3 text-primary"></i>
                      </a>
                      <a on:click|preventDefault={()=> showDeleteModal(resident)} href='#'>
                        <i class="mdi mdi-account-minus icon-md mr-3 text-danger"></i>
                      </a>
                    </td>
                  </tr>
                {/each}
              {:else}
                  <tr>
                    <td colspan='6' class='text-center p-5'>
                      <strong>No Residents Have Been Loaded</strong>
                    </td>
                  </tr>
              {/if}
            </tbody>
            <tfoot>
              <tr>
                <td colspan='6'>
                  <nav class='mt-2' aria-label="Page navigation">
                    <Pagination items={$filteredResidents} on:paginate={paginate}></Pagination>
                  </nav>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
<DeleteResidentModal resident={residentToDelete} on:delete={(event) => deleteResident(event.detail)}></DeleteResidentModal>